import { catchError, throwError, type Observable, type OperatorFunction } from 'rxjs';

import { HttpErrorResponse } from '@angular/common/http';

export function catchHttpError<T, R = T>(
  handler: (error: HttpErrorResponse) => Observable<R>,
): OperatorFunction<T, T | R> {
  return catchError((error: unknown) => {
    if (error instanceof HttpErrorResponse) {
      return handler(error);
    }

    return throwError(() => error);
  });
}
